export const getStoredSession = (quizId) => {
  const sessionStr = localStorage.getItem(`quiz_session_${quizId}`);
  if (!sessionStr || sessionStr === "undefined") return null;
  try {
    return JSON.parse(sessionStr);
  } catch {
    return null;
  }
};

export const storeSession = (quizId, sessionId, startedAt) => {
  if (sessionId && quizId) {
    localStorage.setItem(
      `quiz_session_${quizId}`,
      JSON.stringify({ sessionId, startedAt })
    );
  }
};

export const clearSession = (quizId) => {
  localStorage.removeItem(`quiz_session_${quizId}`);
};